import {app} from "../serviceLMS";
import { GET_RECENT_GROUPS, GET_RECENT_BUNDLE, GET_RECENT_COURSES, GET_RECENT_USERS,GET_DASHBOARD_STATS } from "../URLs";

export const getDashboardStats = async() => {
    try {
    const response = await app.get(GET_DASHBOARD_STATS)
    return response.data.data
  } catch (error) {
    console.error("Error fetching statistics:", error);
    throw new Error(error?.response?.data?.message);
  }
};

export const getRecentCoursesAndBundles = async () => {
  try {
    const response = await app.get(GET_RECENT_COURSES)
    return response.data
  } catch (error) {
    console.error("Error fetching recent courses and bundles:", error);
    throw new Error(error?.response?.data?.message);
  }
}

export const getRecentUser = async () => {

  try {
    const response = await app.get(GET_RECENT_USERS)
    return response.data.data
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
}
export const getRecentCourse = async () => {

  try {
    const response = await app.get('course/api/client-api/course/recent')
    return response.data.data
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
}
export const getRecentBundle = async () => {

  try {
    const response = await app.get('course/api/client-api/course-bundles/recent')
    return response.data.data
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
}

export const getRecentGroups = async () => {

  try {
    const response = await app.get(GET_RECENT_GROUPS)
    return response.data.data
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
}